import { Box, styled } from "@mui/material";

interface PageContainerProps {
	color?: "white" | "transparent";
	fullWidth?: boolean;
}

export const PageContainer = styled(Box)<PageContainerProps>(({ theme, color, fullWidth }) => ({
	padding: theme.spacing(4),
	[theme.breakpoints.down("sm")]: {
		padding: theme.spacing(2),
	},

	display: "flex",
	flexDirection: "column",
	overflow: "auto",
	backgroundColor: color ?? theme.darken(theme.palette.background.default, 0.05),
	...(fullWidth && { width: "100%" }),
}));
